import { createContext, useContext } from "react";
import { useUrlFilters } from "~/hooks/useUrlFilters";
import type { GetAllInquiriesFilters } from "~/lib/api/inquiry";
import { inquiriesUrlFiltersValidationSchema } from "~/validation/inquiries-filters";

export enum InquiriesFiltersVisibility {
  All = 1,
  OnlyMine,
  SharedWithMe,
  SharedByMe,
  ExternalAgency,
}

interface InquiriesFiltersContextData {
  filters: GetAllInquiriesFilters;
  defaultFilters: GetAllInquiriesFilters;
  setFilters: (partialFilters: Partial<GetAllInquiriesFilters>) => void;
}

const InquiriesFiltersContext = createContext(
  {} as InquiriesFiltersContextData,
);

export function useInquiriesFiltersContext() {
  return useContext(InquiriesFiltersContext);
}

const defaultFilters: GetAllInquiriesFilters = {
  userId: undefined,
  name: "",
  startDate: undefined,
  endDate: undefined,
  status: undefined,
  visibilityFilter: InquiriesFiltersVisibility.All,
};

interface InquiriesFiltersContextProviderProps {
  children: React.ReactNode;
}

export const InquiriesFiltersContextProvider: React.FC<
  InquiriesFiltersContextProviderProps
> = ({ children }) => {
  const [filters, setFilters] = useUrlFilters(
    defaultFilters,
    inquiriesUrlFiltersValidationSchema,
  );

  return (
    <InquiriesFiltersContext.Provider
      value={{
        filters,
        setFilters,
        defaultFilters,
      }}
    >
      {children}
    </InquiriesFiltersContext.Provider>
  );
};
